import { MapVersionGeneratedEntity } from "./generated/MapVersionGeneratedEntity";

export abstract class MapVersionEntity extends MapVersionGeneratedEntity {
    // Comment to preserve new line
}
